import type { PropsWithChildren } from 'react';
import { useParams } from 'next/navigation';
import { useGetAccountIdByProjectQuery } from '@frameio/graphql-client/generated';
import { ensureString } from '@frameio/utils/formatters';
import { useActiveAccountId } from '../ActiveEntitiesContext';
import { IsolatedActiveAccountIdContextProvider } from '../ActiveEntitiesContext/ActiveAccountIdContext';

export const RouteDerivedAccountId = ({ children }: PropsWithChildren) => {
  const params = useParams();
  const activeAccountId = useActiveAccountId();
  const projectId = ensureString(params.projectId);
  const canDeriveAccountIdFromPathParams = Boolean(projectId);

  // Get account ID from project ID in route path
  const { data: projectData } = useGetAccountIdByProjectQuery({
    variables: { projectId },
    skip:
      !projectId ||
      !canDeriveAccountIdFromPathParams ||
      Boolean(activeAccountId),
  });

  const accountId =
    activeAccountId ||
    projectData?.account?.project?.workspace?.accountId ||
    undefined;

  return (
    <IsolatedActiveAccountIdContextProvider accountId={accountId}>
      {children}
    </IsolatedActiveAccountIdContextProvider>
  );
};
